import { Action } from "types";
import {
  ActionTypes,
  State,
  RequestAction,
  RequestSuccessAction,
  RequestFailureAction,
  ResetAction,
} from "./types";

const ACTION_HANDLERS = {
  [ActionTypes.CP_APP_EVAL_SKUS_REQUEST]: (
    state: State,
    action: RequestAction
  ) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [ActionTypes.CP_APP_EVAL_SKUS_REQUEST_SUCCESS]: (
    state: State,
    action: RequestSuccessAction
  ) => ({
    ...state,
    loading: false,
    error: null,
    data: action.data,
  }),
  [ActionTypes.CP_APP_EVAL_SKUS_REQUEST_FAILURE]: (
    state: State,
    action: RequestFailureAction
  ) => ({
    ...state,
    loading: false,
    error: action.error,
    data: null,
  }),
  [ActionTypes.CP_APP_EVAL_SKUS_RESET]: (
    state: State,
    action: ResetAction
  ) => ({
    ...initialState,
  }),
};

const initialState: State = {
  loading: false,
  error: null,
  data: null,
};

export default function cpAppEvalSKUsPostReducer(
  state: State = initialState,
  action: Action
): State {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
